import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { eventActions } from "../../../_actions";
import { useDispatch, useSelector } from "react-redux";
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Pagination from '@material-ui/lab/Pagination';
import moment from 'moment';
import EditCustomerTier from "../../../components/ModalPopup/EditCustomerTier";
import { isPermission, authorizedMessage } from '../../../_helpers/commonAPI';
import { toast } from 'react-toastify';
import Loader from "../../../components/Loader/Loader";
import AuthLoader from '../../../components/AuthLoader';
import AuthorizedMessage from '../../../components/AuthorizedMessage';
import { toCommas } from '../../../_helpers';


const headCells = [
    { id: 'number', numeric: false, disablePadding: true, label: 'Sold To Number' },
    { id: 'NumberofTreesPlanted', numeric: true, disablePadding: false, label: 'Number of Trees Planted' },
    { id: 'createDate', numeric: true, disablePadding: false, label: 'Created Date' },

];

function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>

                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={'asc'}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {

    },
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;

};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },

    container: {
        maxHeight: "calc(90vh - 147px)",
    },

    paper: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

const page_size = 50;

export default function ESGCampaignDataGrid({ totalCount, isLoadingTrue, filterData, setPage, page }) {
    const classes = useStyles();
    const [selected, setSelected] = React.useState([]);

    const [dense, setDense] = React.useState(false);
    const FontChange = useSelector((state) => state.fontsizechanger.fontsizechanger);
    const [showData, setShowData] = useState([])


    const handleChangePage = (event, page_number) => {
        const SD = filterData.slice((page_number - 1) * page_size, page_number * page_size);
        setShowData(SD)
        setPage(page_number);
    };

    useEffect(() => {
        setShowData(filterData.slice(0, 50))
    }, [filterData])



    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <TableContainer className={classes.container}>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                        stickyHeader aria-label="sticky table"
                        style={{ fontSize: "20px" }}
                    >
                        <EnhancedTableHead
                            classes={classes}
                            rowCount={totalCount}
                        />
                        {isLoadingTrue ? <Loader /> :
                            <TableBody>
                                {
                                    showData && showData.length === 0 ? <div className="no_record">No Record Found</div> :
                                        showData && showData.map((row, index) => {
                                            return (
                                                <TableRow
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={index}
                                                >
                                                    <TableCell style={{ fontSize: `${FontChange}px` }} component="th" scope="row" padding="none">
                                                        {row.accountNumber}
                                                    </TableCell>
                                                    <TableCell style={{ fontSize: `${FontChange}px` }} align="right">{toCommas(row.treesPlanted)}</TableCell>
                                                    <TableCell style={{ fontSize: `${FontChange}px` }} align="right">{moment(row.createdAt).format('DD-MM-yyyy')}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                            </TableBody>
                        }
                    </Table>
                </TableContainer>
                {!isLoadingTrue &&
                    <div className="pagination_sec mt-2">
                        <Pagination count={Math.ceil(filterData && filterData.length / 50)} page={page} onChange={handleChangePage} variant="outlined" color="secondary" />
                    </div>
                }
            </Paper>
        </div>
    );
}


